package com.starparty.app.astro0.renderers

import com.starparty.app.astro0.SP_Canvas
import com.starparty.app.astro0.SP_Paint
import com.starparty.app.geometry.SP_Point

internal object TextRenderer {
    fun paintLabel(
        g: SP_Canvas,
        p: SP_Paint,
        titlePt: SP_Point,
        title: String
    ) {
        //   Typeface typeface = Typeface.createFromAsset((g.getAssets(), "Helvetica.ttf");
        //   paint.setTypeface(typeface);
        val boundsResult = p.getTextBounds(title)
        val textHeight = boundsResult.height
        val titleOffsetX = 15
        val xPos = titlePt.x + titleOffsetX
        val yPos = titlePt.y + textHeight / 2
        g.drawText(title, xPos, yPos, p)
    }
}